module.exports = __webpack_public_path__ + "assets/img/dfa-iot.cb0ffc06.png";